import type { UserType } from "@bbj-types/user/enum";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosUser } from "./axios";

interface TPatchUserBody {
  lastName?: string;
  firstName?: string;
  position?: string;
  phone?: string;
  isDisabled?: boolean;
  department?: string;
  departmentPhone?: string;
  departmentEmail?: string;
  manager?: ObjectId | null;
  organisations?: {
    organisation: string;
    roleV2: string;
    isMaster: boolean;
    teams?: string[];
  }[];
}

export const usePatchUser = () => {
  const [state, execute, cancel] = axiosUser<void, TPatchUserBody, unknown>(
    {
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId, data: TPatchUserBody, type: UserType) => {
      return execute({
        url: `/${type}/${id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
